module.exports = __webpack_public_path__ + "img/sc-3-act.09eeba71.png";